<ng-container *ngIf="eventDetailData">
  <section class="section-blog-hero">
    <div class="section-container">
      <div class="event-article-hero">
        <div class="left-content">
          <h1 class="product-hero-header grey-800">
            {{ eventDetailData?.header }}
          </h1>
          <div class="tags">
            <svg
              _ngcontent-serverApp-c199=""
              width="18"
              height="21"
              viewBox="0 0 18 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                _ngcontent-serverApp-c199=""
                d="M13.7502 2.56V1C13.7502 0.59 13.4102 0.25 13.0002 0.25C12.5902 0.25 12.2502 0.59 12.2502 1V2.5H5.75023V1C5.75023 0.59 5.41023 0.25 5.00023 0.25C4.59023 0.25 4.25023 0.59 4.25023 1V2.56C1.55023 2.81 0.240229 4.42 0.0402292 6.81C0.0202292 7.1 0.260229 7.34 0.540229 7.34H17.4602C17.7502 7.34 17.9902 7.09 17.9602 6.81C17.7602 4.42 16.4502 2.81 13.7502 2.56Z"
                fill="#969CA4"
              ></path>
              <path
                _ngcontent-serverApp-c199=""
                d="M17 8.83984H1C0.45 8.83984 0 9.28984 0 9.83984V15.9998C0 18.9998 1.5 20.9998 5 20.9998H13C16.5 20.9998 18 18.9998 18 15.9998V9.83984C18 9.28984 17.55 8.83984 17 8.83984ZM6.21 17.2098C6.16 17.2498 6.11 17.2998 6.06 17.3298C6 17.3698 5.94 17.3998 5.88 17.4198C5.82 17.4498 5.76 17.4698 5.7 17.4798C5.63 17.4898 5.57 17.4998 5.5 17.4998C5.37 17.4998 5.24 17.4698 5.12 17.4198C4.99 17.3698 4.89 17.2998 4.79 17.2098C4.61 17.0198 4.5 16.7598 4.5 16.4998C4.5 16.2398 4.61 15.9798 4.79 15.7898C4.89 15.6998 4.99 15.6298 5.12 15.5798C5.3 15.4998 5.5 15.4798 5.7 15.5198C5.76 15.5298 5.82 15.5498 5.88 15.5798C5.94 15.5998 6 15.6298 6.06 15.6698C6.11 15.7098 6.16 15.7498 6.21 15.7898C6.39 15.9798 6.5 16.2398 6.5 16.4998C6.5 16.7598 6.39 17.0198 6.21 17.2098ZM6.21 13.7098C6.02 13.8898 5.76 13.9998 5.5 13.9998C5.24 13.9998 4.98 13.8898 4.79 13.7098C4.61 13.5198 4.5 13.2598 4.5 12.9998C4.5 12.7398 4.61 12.4798 4.79 12.2898C5.07 12.0098 5.51 11.9198 5.88 12.0798C6.01 12.1298 6.12 12.1998 6.21 12.2898C6.39 12.4798 6.5 12.7398 6.5 12.9998C6.5 13.2598 6.39 13.5198 6.21 13.7098ZM9.71 17.2098C9.52 17.3898 9.26 17.4998 9 17.4998C8.74 17.4998 8.48 17.3898 8.29 17.2098C8.11 17.0198 8 16.7598 8 16.4998C8 16.2398 8.11 15.9798 8.29 15.7898C8.66 15.4198 9.34 15.4198 9.71 15.7898C9.89 15.9798 10 16.2398 10 16.4998C10 16.7598 9.89 17.0198 9.71 17.2098ZM9.71 13.7098C9.66 13.7498 9.61 13.7898 9.56 13.8298C9.5 13.8698 9.44 13.8998 9.38 13.9198C9.32 13.9498 9.26 13.9698 9.2 13.9798C9.13 13.9898 9.07 13.9998 9 13.9998C8.74 13.9998 8.48 13.8898 8.29 13.7098C8.11 13.5198 8 13.2598 8 12.9998C8 12.7398 8.11 12.4798 8.29 12.2898C8.38 12.1998 8.49 12.1298 8.62 12.0798C8.99 11.9198 9.43 12.0098 9.71 12.2898C9.89 12.4798 10 12.7398 10 12.9998C10 13.2598 9.89 13.5198 9.71 13.7098ZM13.21 17.2098C13.02 17.3898 12.76 17.4998 12.5 17.4998C12.24 17.4998 11.98 17.3898 11.79 17.2098C11.61 17.0198 11.5 16.7598 11.5 16.4998C11.5 16.2398 11.61 15.9798 11.79 15.7898C12.16 15.4198 12.84 15.4198 13.21 15.7898C13.39 15.9798 13.5 16.2398 13.5 16.4998C13.5 16.7598 13.39 17.0198 13.21 17.2098ZM13.21 13.7098C13.16 13.7498 13.11 13.7898 13.06 13.8298C13 13.8698 12.94 13.8998 12.88 13.9198C12.82 13.9498 12.76 13.9698 12.7 13.9798C12.63 13.9898 12.56 13.9998 12.5 13.9998C12.24 13.9998 11.98 13.8898 11.79 13.7098C11.61 13.5198 11.5 13.2598 11.5 12.9998C11.5 12.7398 11.61 12.4798 11.79 12.2898C11.89 12.1998 11.99 12.1298 12.12 12.0798C12.3 11.9998 12.5 11.9798 12.7 12.0198C12.76 12.0298 12.82 12.0498 12.88 12.0798C12.94 12.0998 13 12.1298 13.06 12.1698C13.11 12.2098 13.16 12.2498 13.21 12.2898C13.39 12.4798 13.5 12.7398 13.5 12.9998C13.5 13.2598 13.39 13.5198 13.21 13.7098Z"
                fill="#969CA4"
              ></path>
            </svg>
            <p class="text-xl text-nowrap">
              {{ eventDetailData?.dateTime | date: 'MMMM d, y h:mm a' }}
            </p>
          </div>
          <div class="tags">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M21.15 6.17C20.74 5.95 19.88 5.72 18.71 6.54L17.24 7.58C17.13 4.47 15.78 3.25 12.5 3.25H6.5C3.08 3.25 1.75 4.58 1.75 8V16C1.75 18.3 3 20.75 6.5 20.75H12.5C15.78 20.75 17.13 19.53 17.24 16.42L18.71 17.46C19.33 17.9 19.87 18.04 20.3 18.04C20.67 18.04 20.96 17.93 21.15 17.83C21.56 17.62 22.25 17.05 22.25 15.62V8.38C22.25 6.95 21.56 6.38 21.15 6.17ZM11 11.38C9.97 11.38 9.12 10.54 9.12 9.5C9.12 8.46 9.97 7.62 11 7.62C12.03 7.62 12.88 8.46 12.88 9.5C12.88 10.54 12.03 11.38 11 11.38Z"
                fill="#6B747F"
              />
            </svg>
            <p class="text-xl text-nowrap">{{ eventDetailData?.location }}</p>
          </div>
        </div>
        <div>
          <div *ngIf="!hasEventTimeElapsed" class="absolute-form">
            <p class="form-title">Register to attend</p>
            <div id="hubspotRegisterForm" class="w-100"></div>
          </div>
          <div *ngIf="hasEventTimeElapsed" class="event-passed-wrapper">
            <div class="white__card p-md wys" *ngIf="subscribeformData">
              <h2 class="h3 text-center">
                {{
                  hasEventTimeElapsed
                    ? 'This event has concluded'
                    : subscribeformData?.header
                }}
              </h2>
              <div
                class="wys text-center margin-top-2rem"
                *ngIf="subscribeformData.button && !hasEventTimeElapsed"
              >
                <a
                  href="{{ subscribeformData?.button?.fields?.redirectLink }}"
                  target="{{ subscribeformData?.button?.fields?.actionType }}"
                  class="cs-btn p-md"
                  style="color: white; font-weight: bold"
                  >{{ subscribeformData?.button?.fields?.buttonText }}</a
                >
              </div>
              <div
                class="wys text-center margin-top-1half-rem"
                [innerHtml]="subscribeformData?.text | toHtml"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="section">
    <section class="section-container">
      <div class="webinar-detail-wrapper">
        <div class="detail-content">
          <div class="webinar-detail">
            <div
              class="wys"
              [innerHtml]="eventDetailData?.richTextTop | toHtml"
            ></div>
            <div
              class="greenlight p-md-5 p-4"
              *ngIf="eventDetailData?.blogContentAdPanel?.header"
            >
              <div class="row">
                <div class="col-md-12 text-center">
                  <h2 class="cs_h3">
                    {{ eventDetailData?.blogContentAdPanel?.header }}
                  </h2>
                  <a
                    href="{{
                      eventDetailData?.blogContentAdPanel?.button?.url
                    }}"
                    target="{{
                      eventDetailData?.blogContentAdPanel?.button?.target
                    }}"
                    class="cs-btn"
                    >{{ eventDetailData?.blogContentAdPanel?.button?.text }}</a
                  >
                </div>
              </div>
            </div>
            <div class="" *ngIf="eventDetailData?.adPanelTitle">
              <h4 class="mb-4">{{ eventDetailData?.adPanelTitle }}</h4>
              <div
                class="wys"
                [innerHtml]="eventDetailData?.adPanelContent | toHtml"
              ></div>
            </div>
            <div
              class="wys"
              [innerHtml]="eventDetailData?.articleContent | toHtml"
            ></div>
            <div class="pb-lg-4">
              <div
                class="wys"
                [innerHtml]="eventDetailData?.richTextBottom | toHtml"
              ></div>
            </div>
          </div>
        </div>
        <div class="speaker-details">
          <h4>Speakers</h4>
          <div class="overflow-x-scroll">
            <ul class="list-unstyled dt_list speaker_list pt-2 flex gap-24">
              <li
                class=""
                *ngFor="let speaker of eventDetailData?.speakersDetails"
              >
                <span class="icon_c_set">
                  <img
                    *ngIf="speaker?.fields?.iconImage?.fields?.file?.url"
                    src="{{ speaker?.fields?.iconImage?.fields?.file?.url }}"
                    alt="{{ speaker?.fields?.iconImage?.fields?.title }}"
                /></span>
                <p class="name">
                  <strong class="d-block">{{ speaker?.fields?.title }}</strong>
                  <span class="text-light">{{
                    speaker?.fields?.subTitle
                  }}</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="social-links">
          <p class="text-xl font-bold">Share this event</p>
          <ul class="">
            <li>
              <a (click)="social('facebook')">
                <img
                  src="./assets/images/ico-facebook.svg"
                  class="footer-social-icon"
                  alt="Facebook"
                />
              </a>
            </li>
            <li>
              <a (click)="social('twitter')">
                <img
                  src="/assets/images/ico-twitter.svg"
                  class="footer-social-icon"
                  alt="Twitter"
                />
              </a>
            </li>
            <li>
              <a (click)="social('linkedin')">
                <img
                  src="/assets/images/ico-linkedin.svg"
                  class="footer-social-icon"
                  alt="LinkedIn"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </section>
</ng-container>
